export const PER_PAGE_OPTIONS = [
  { label: '10', value: 10 },
  { label: '25', value: 25 },
  { label: '50', value: 50 },
  { label: '100', value: 100 },
];

export enum STATUSES {
  AUTHENTICATION = 401,
  AUTHORIZATION = 403,
  CONFLICT = 409,
  DATA_ERROR = 422,
  INVALID_DATA = 400,
  NOT_FOUND = 404,
  REQUEST_TIMEOUT = 408,
  TOO_MANY_REQUESTS = 429,
}

export const ERROR_MESSAGES = {
  UPDATE_PASSWORD: 'UPDATE_PASSWORD',
};

export const CASHIER = 'CASHIER';
export const CREDIT_CARD = 'CREDIT_CARD';

export enum FILTRATION_TYPES {
  BIG_DECIMAL = 'BigDecimal',
  BOOLEAN = 'Boolean',
  DOUBLE = 'Double',
  INTEGER = 'Int',
  LOCAL_DATE = 'LocalDate',
  LONG = 'Long',
  STRING = 'String',
  ZONED_DATE_TIME = 'ZonedDateTime',
  ZONED_OFFSET = 'ZoneOffset',
}

export const INTEGER_REG_EXP = /^[0-9]*$/;
export const getIntRegExp = (min = 0, max = 2) => new RegExp(`^[0-9]{${min},${max}}$`);
export const DECIMAL_REG_EXP = /^\d+\.?\d*$/;
export const NEGATIVE_DECIMAL_REG_EXP = /^(-|\d+|-?\d+\.)?\d*$/;
export const FIAT_DECIMAL_REG_EXP = /^\d+\.?(\d{0,2})?$/;
export const FEE_RATE_DECIMAL_REG_EXP = /^\d+\.?(\d{0,4})?$/;
export const COMMISSION_PERCENT_REG_EXP = /^(\d{0,2}(\.\d{0,2})?|100)?$/;

export const MAX_AMOUNT = 1000000000;

export const GRAPHS_LIMIT = 20;

export const MAX_INT = 2147483647;
export const MAX_NUMBER_LENGTH = 50;

/** Timeout in seconds */
export const GROUP_EDIT_CONFIRMATION_TIMEOUT = 5;

/** Auto-close delay (ms) for inline-edit validation error toasts — longer than
 * the 3s default so the surfaced backend reason stays readable. */
export const INLINE_EDIT_ERROR_DISMISS_MS = 8000;

export const LOCAL_SEARCH_KEY = 'localSearch';
export const SHOW_CHILD_ENTITIES = 'showChildEntities';

export const SMALL_SCREEN_WIDTH = 1730;

export const baseThemeValues = {
  inherit: 'inherit',
};

export const BASE_TIME_MASK = 'dd.MM.yy, HH:mm:ss';
export const DATE_TIME_MASK = 'hh:mm:ss a, MMM d, yyyy';
export const DATE_MASK = 'MMM d, yyyy';
export const TIMEZONE_MASK = "yyyy-MM-dd'T'HH:mm:ssXXX";
export const TIMEZONE_MASK_NEW = "yyyy-MM-dd'T'HH:mm:ss'Z'";
export const LOCAL_DATE_MASK = 'yyyy-MM-dd';

export const BINARY_OPTIONS = [
  { label: 'common.on', value: 'true' },
  { label: 'common.off', value: 'false' },
];

export const YES_NO_BINARY_OPTIONS = [
  { label: 'common.no', value: 'N' },
  { label: 'common.yes', value: 'Y' },
];

export const APPROVAL_BINARY_OPTIONS = [
  { label: 'common.no', value: 'false' },
  { label: 'common.yes', value: 'true' },
];

export const VERIFIED_BINARY_OPTIONS = [
  { label: 'notification.outputChannels.status.verified', value: 'true' },
  { label: 'notification.outputChannels.status.notVerified', value: 'false' },
];

export const STATUS_BINARY_OPTIONS = [
  { label: 'common.enabled', value: 'true' },
  { label: 'common.disabled', value: 'false' },
];

export const VOLUME_METRIC_OPTIONS = [
  { label: 'common.count', value: 'false' },
  { label: 'common.volumeEur', value: 'true' },
];

export const BINARY_REVERSE_MAPPING = {
  false: false,
  true: true,
};

export const GOOGLE_FONT_BINARY_OPTIONS = [
  { label: 'themeEditor.google', value: 'true' },
  { label: 'themeEditor.base', value: 'false' },
];

export const BINARY_INTL_MAPPING = {
  false: 'common.no',
  true: 'common.yes',
};

export const BINARY_STRING_MAPPING = {
  FALSE: 'false',
  TRUE: 'true',
};

export const MAX_MSEC = 31556952000; // max msec from DB
export const MAX_DAYS = 6;
export const MAX_HOURS = 23;
export const MAX_PERIOD_MINUTES = 49;
export const MAX_MINUTES = 59;
export const ZERO_MINUTES = '00';

export const MINUTE_MSEC = 1000 * 60; // milliseconds in one minute
export const HOUR_MSEC = MINUTE_MSEC * 60; // milliseconds in one hour
export const DAY_MSEC = HOUR_MSEC * 24; // milliseconds in one day
export const WEEK_MSEC = DAY_MSEC * 7; // milliseconds in one week

export const KB_BYTES_SIZE = 1024;

export const INPUT_DELETE_EVENT = 'deleteContentBackward';

export const gridConfigFallback = {
  columns: [],
  gridFilters: new Map(),
  sectionsFiltersMap: {},
};

export const TERMINAL_LINK_PARAM = 'TERMINAL_LINK_PARAM';

export const BANK_TERMINAL_PARAM = 'BANK_TERMINAL_PARAM';

export const BANK_PARAM = 'BANK_PARAM';

export const ANY = 'ANY';
export const GENERAL = 'GENERAL';

export const IS_NULL = '*null*';

export const PASSWORD_FIELD = '********';

export enum KEYBOARD_KEYS {
  ARROW_LEFT = 'ArrowLeft',
  BACKSPACE = 'Backspace',
  ENTER = 'Enter',
  ESCAPE = 'Escape',
}

export const ORGANIZATION = 'Organization';

export enum PERIOD_TYPES {
  DAY = 'day',
  HOUR = 'hour',
  MINUTE = 'minute',
  WEEK = 'week',
}

export const TURKEY = 'Turkey';
